export default "__VITE_ASSET__DxLUw6jD__"